(function (module) {
    'use strict';

    module.config(['formlyConfigProvider', (formlyConfigProvider) => {

        let unique = 1;

        formlyConfigProvider.setType({
            name: 'repeatSectionTable',
            template: `
                <div>
                    <div>
                        <md-table-container>
                                <table style="table-layout:fixed;" md-table class="dataTable row-border timer-table">
                                    <thead md-head>
                                    <tr md-row>
                                        <th md-column>Time</th>
                                        <th md-column>Value</th>
                                        <th md-column></th>
                                        <th md-column></th>
                                    </tr>
                                    </thead>
                                    <tbody md-body>
                                    <tr id={{$index}} ng-repeat="element in model[options.key]" ng-init="fields = copyFields(to.fields)">
                                        <td class="table-vertical-label">
                                         <md-input-container>
                                                <md-select ng-model="element.time"
                                                           placeholder="Select time"
                                                           ng-required="true">
                                                    <md-option ng-value="time === 'Not Set' ? null : time "
                                                               ng-repeat="time in times">
                                                        {{time }}
                                                    </md-option>
                                                </md-select>
                                            </md-input-container>
                                        </td>
                                        <td colspan="2">
                                            <md-slider-container>
                                                <md-slider min="0" max="100" step="1" ng-model="element.value" class="md-accent">
                                          </md-slider>
                                           <md-input-container>
                                                <input type="number" ng-model="element.value" required />
                                            </md-input-container>
                                        </md-slider-container>
                                        </td>
                                        <td style="max-width: 50px;a">
                                        <md-button style="border: none !important;" class=" md-warn delete-button  md-default-theme md-ink-ripple" ng-click="remove($index)">
                                            <i class="fa fa-trash-o md-warn active"></i>
                                        </md-button>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </md-table-container>
                    </div>

                    <!-- ADD BUTTON -->
                    <div ng-show="to && to.maxItems && model[options.key].length >= to.maxItems">{{to.maxItemsMessage}}</div>
                    <div layout="row" class="button-wrapper" layout-align="end center">
                        <md-button class="md-raised md-primary main-button" ng-disabled="to && to.maxItems && model[options.key].length >= to.maxItems" ng-click="add()">
                            <i class="s16 fa fa-plus"></i>
                            <span>{{to.addButtonText}}</span>
                        </md-button>
                    </div>
                </div>
            `,
            controller: ['$scope', function ($scope) {
                $scope.class = 'expand';

                $scope.times = _.flattenDeep(Array(24).fill().map((_, i) => [`${i}:00`, `${i}:15`, `${i}:30`, `${i}:45`]));

                $scope.collapse = (event) => {

                    // parent class
                    angular.element(event.currentTarget).closest('.repeated-section').toggleClass('collapsed');

                    // buttons classes
                    if (event.currentTarget.className === 'fa fa-compress') {
                        event.currentTarget.className = 'fa fa-expand';
                    } else {
                        event.currentTarget.className = 'fa fa-compress';
                    }
                };

                $scope.formOptions = { formState: $scope.formState };

                $scope.add = function () {
                    if (!$scope.model[$scope.options.key]) $scope.model[$scope.options.key] = [];
                    $scope.model[$scope.options.key].push({});
                };

                $scope.remove = function (index) {
                    $scope.model[$scope.options.key].splice(index, 1);
                    $scope.form.$setDirty();
                };

                $scope.copyFields = function copyFields(fields) {
                    fields = angular.copy(fields);
                    addRandomIds(fields);
                    return fields;
                };

                $scope.up = function (index) {
                    const array = $scope.model[$scope.options.key];
                    // if prev exist
                    if (array[index - 1]) {
                        // Swap elements
                        array.splice(index - 1, 2, array[index], array[index - 1]);
                        $scope.form.$setDirty();
                    }
                };

                $scope.down = function (index) {
                    const array = $scope.model[$scope.options.key];
                    // if next exist
                    if (array[index + 1]) {
                        // Swap elements
                        array.splice(index, 2, array[index + 1], array[index]);
                        $scope.form.$setDirty();
                    }
                };

                function addRandomIds(fields) {
                    unique++;
                    angular.forEach(fields, function (field, index) {
                        if (field.fieldGroup) {
                            addRandomIds(field.fieldGroup);
                            return; // fieldGroups don't need an ID
                        }

                        if (field.templateOptions && field.templateOptions.fields) {
                            addRandomIds(field.templateOptions.fields);
                        }
                        field.id = field.id || (field.key + '_' + index + '_' + unique + getRandomInt(0, 9999));
                    });
                }

                function getRandomInt(min, max) {
                    return Math.floor(Math.random() * (max - min)) + min;
                }

            }],

        });

    }]);
})(angular.module('rocket.components'));
